import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tray-theme-editor__section tray-theme-editor__section--spaced tray-theme-editor__store-info" }
const _hoisted_2 = { class: "tray-theme-editor__store-info-label" }
const _hoisted_3 = { class: "tray-theme-editor__store-info-themeid" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("section", { class: "tray-theme-editor__section tray-theme-editor__store-info" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "tray-theme-editor__store-info-divider" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThemeInfo = _resolveComponent("ThemeInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('store-info.code-theme')), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.theme.id), 1),
      _createVNode(_component_ThemeInfo, { class: "tray-theme-editor__store-info__dropdown" })
    ]),
    _hoisted_4
  ], 64))
}